import { createSlice } from "@reduxjs/toolkit";
import { getListSuspensionPointSetting } from "../../api/suspensionPointSetting/suspensionPointSetting";

// giá trị khởi tạo của state
const initialState = {
  listSuspensionPointSetting: [],
  isLoadSuspensionPointSetting: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const suspensionPointSettingSlice = createSlice({
  name: "suspensionPointSetting", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListSuspensionPointSetting.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadSuspensionPointSetting = true;
        state.error = null;
      })
      .addCase(getListSuspensionPointSetting.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadSuspensionPointSetting = false;
        state.listSuspensionPointSetting = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListSuspensionPointSetting.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadSuspensionPointSetting = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = suspensionPointSettingSlice.actions;
export default suspensionPointSettingSlice.reducer;
